<template>
  <div id="header" style="z-index: 5;">
    <div class="container header-container">
      <img
      v-if="$vuetify.theme.dark"
      src="@/assets/forecast-logo-light.png"
      alt="DDHQ"
      class="logo"
      @click="$router.push({ name: 'presidential_landing' }).catch(() => {})">
      <img
      v-else
      src="@/assets/forecast-logo.png"
      alt="DDHQ"
      class="logo"
      @click="$router.push({ name: 'presidential_landing' }).catch(() => {})">
      <template>
        <div style="list-style: none; display: flex; align-items: center;">
          <template v-if="!mobilePhone">
            <div>
<!--              <v-btn class="header-menu-item"-->
<!--              :style="$route.name === 'senate_runoff_landing' ? `color: ${$vuetify.theme.currentTheme.text} !important` : ''" text tile small @click="$router.push({ name: 'senate_runoff_landing' }).catch(() => {})">Senate (Runoff)</v-btn>-->
              <v-btn class="header-menu-item"
              :style="$route.name === 'presidential_landing' ? `color: ${$vuetify.theme.currentTheme.text} !important` : ''" text tile small @click="$router.push({ name: 'presidential_landing' }).catch(() => {})">President</v-btn>
              <v-btn class="header-menu-item"
              :style="$route.name === 'senate_landing' ? `color: ${$vuetify.theme.currentTheme.text} !important` : ''" text tile small @click="$router.push({ name: 'senate_landing' }).catch(() => {})">Senate</v-btn>
              <v-btn class="header-menu-item"
              :style="$route.name === 'house_landing' ? `color: ${$vuetify.theme.currentTheme.text} !important` : ''" text tile small @click="$router.push({ name: 'house_landing' }).catch(() => {})">House</v-btn>
            </div>
            <!-- <li class="header-menu-item" style="margin: 0 10px;">
              <router-link class="hide-decoration" :to="{ name: 'presidential_landing' }"
              :style="$route.name === 'presidential_landing' ? 'color: #222 !important;' : ''">Presidential Model</router-link>
            </li>
            <li class="header-menu-item" style="margin: 0 10px;">
              <router-link class="hide-decoration" :to="{ name: 'senate_landing' }"
              :style="$route.name === 'senate_landing' ? 'color: #222 !important;' : ''">Senate</router-link>
            </li>
            <li class="header-menu-item" style="margin: 0 10px;">
              <router-link class="hide-decoration" :to="{ name: 'house_landing' }"
              :style="$route.name === 'house_landing' ? 'color: #222 !important;' : ''">House</router-link>
            </li> -->
          </template>
          <v-menu bottom left>
            <template v-slot:activator="{ on }">
              <v-btn class="header-menu-item" text small v-on="on">
                More
                <v-icon right dark>mdi-chevron-down</v-icon>
              </v-btn>
              <!-- <v-btn text small v-on="on">
                <span class="header-menu-item" style="display: flex; align-items: center;">
                  More
                  <v-icon right dark>mdi-chevron-down</v-icon>
                </span>
              </v-btn> -->
            </template>

            <v-list>
              <v-list-item @click="$router.push({ name: 'about' })">
                <v-list-item-title>About</v-list-item-title>
              </v-list-item>
              <v-list-item @click="$router.push({ name: 'methodology' })">
                <v-list-item-title>Methodology</v-list-item-title>
              </v-list-item>
              <v-list-item @click="openLink('https://decisiondeskhq.com/')">
                <v-list-item-title>DDHQ Blog</v-list-item-title>
              </v-list-item>
              <v-list-item @click="openLink('https://results.decisiondeskhq.com/')">
                <v-list-item-title>Results</v-list-item-title>
              </v-list-item>
              <v-list-item @click="logout" v-if="$auth.authenticated">
                <v-list-item-title>Log Out</v-list-item-title>
              </v-list-item>
              <v-list-item @click="$router.push({ name: 'login' })" v-else>
                <v-list-item-title>Log In</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

const name = 'fc_header'

const computed = {
  ...mapGetters({
    mobile: 'ux/mobile',
    mobilePhone: 'ux/mobilePhone'
  })
}

const methods = {
  logout () {
    this.$auth.logout()
    if ((this.$route.meta || {}).auth === true) {
      this.$router.push('/')
    }
  },
  openLink (url) {
    window.open(url, '_blank')
  }
}

export default {
  name,
  computed,
  methods
}
</script>

<style>
.header-container {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  justify-content: space-between;
}

.nav-container {
  padding-bottom: 10px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  align-items: center;
}

.logo {
  height: 40px;
  cursor: pointer;
}

.header-menu-item {
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 1px;
  text-transform: uppercase;
  cursor: pointer;
  color: #9e9e9e !important;
}

.header-menu-item a {
  color: #9e9e9e !important;
}

.mobile-nav-btn {
  margin: 0 5px;
}
</style>
